<template>
<div class="container-fluid intel-body bg-grey-b">
    <!-- intro -->
    <div class="row">
        <div class="bld-intel h-full">
            <div class="container">
                <div class="intel-intro col-xs-12 p-a-0 m-t-xl">
                    <div class="col-xs-12 col-md-7">
                        <div class="intro-title text-bold text-green text-center text-upper">
                            <h1>Introducing</h1>
                            <h3>the 8th Gen Intel® core™ processor</h3>
                        </div>
                        <div class="intel-img text-center">
                            <img src="/images/intel-img/Intel-Logos.png" alt="" class="w-full">
                        </div>
                        <div class="text text-light text-white text-center">
                            <p>
                                Be ready for amazing experiences in gaming, VR, and entertainment wherever your computing takes you with the 8th Generation Intel® Core™ processor family. This new generation of processors extends all the capabilities users have come to love in our desktop
                                platforms with advanced innovations that deliver exciting new features to immerse you in the incredible experiences on a variety of form factors.
                            </p>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-5 p-a-0">
                        <div class="intel-img">
                            <img src="/images/intel-img/Case-Image.png" alt="" class="w-full">
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <!-- email-submit -->
                    <div class="intel-submit p-x text-white text-normal text-upper">
                        <h3>Sign up and be the first to know when it becomes available on BLD!</h3>
                        <div class="form-group">
                            <div class="input-group">
                                <input type="text" class="form-control" placeholder="EMAIL*">
                                <span class="input-group-btn">
                      <button class="btn btn-green btn-outline" type="submit">SUBMIT</button>
                    </span>
                            </div>
                        </div>
                    </div>
                    <!-- /.email-submit -->
                    <hr>
                </div>
                <div class="new-intel col-xs-12 p-a-0 m-t-md">
                    <!-- new-8th -->
                    <div class="title text-green text-bold text-upper text-center">
                        <h3>the new 8th Gen Intel® Core™ Processor features</h3>
                    </div>

                    <div class="bld-intel m-t-md">
                        <div class="text text-normal text-white text-center">
                            <p>
                                The 8th Generation Intel Core processors redefine mainstream desktop PC performance with up to six cores for more processing power—that’s two more cores than the previous generation Intel Core processor family—Intel® Turbo Boost 2.0 technology to increase
                                the maximum turbo frequency up to 4.7 GHz, and up to 12 MB of cache memory. Intel® Hyper-Threading Technology delivers up to 12-way multitasking support in the latest generation of Intel Core processors.
                            </p>
                        </div>
                    </div>

                    <div class="core-li">
                        <div class="col-xs-12 col-md-5 p-a-0">
                            <div class="intel-img">
                                <img src="/images/intel-img/Intel-Product-Image.png" alt="" class="w-full">
                            </div>
                        </div>
                        <div class="col-xs-12 col-md-7">
                            <div class="intel-list m-t-lg">
                                <ul class="list-none text-light">
                                    <li>An impressive portfolio of standard and unlocked systems for a broad range of usages and performance levels.</li>
                                    <li>New system acceleration when paired with Intel® Optane™ memory to deliver amazing system responsiveness.</li>
                                    <li>Intel Turbo Boost 2.0 technology to give you that extra burst of performance when you need it.</li>
                                    <li>Intel Hyper-Threading technology, which allows each processor core to work on two tasks at the same time, improving multitasking, speeding up workflows, and accomplishing more in less time.</li>
                                    <li>DDR4 RAM memory technology support, which allows systems to have up to 64 GB of memory and up to 2666 MT/s memory transfer speeds.</li>
                                    <li>The ability to set an overclocked ratio per core with unlocked processors,when paired with select chipset SKUs, to provide you more control and more granularity for overclocking your platform.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <!-- /.new-8th -->
                    <div class="clearfix"></div>
                    <hr>
                </div>
                <div class="system-requirements col-xs-12 p-a-0 m-t-md">
                    <!-- new-8th -->
                    <div class="title text-green text-bold text-upper text-center">
                        <h3>System Requirements</h3>
                    </div>

                    <div class="bld-intel m-t-md">
                        <div class="text text-normal text-white">
                            <p>
                                The predicted FPS is at 1920x1080p resolution using each game’s highest graphic setting. FPS (Frames Per Second) is a measurement of the PC's game performance in game. BLD guarantees all predictions for games within an accuracy of +/- 10%.
                            </p>
                        </div>
                    </div>

                    <div class="core-li m-t-md">
                        <div class="col-xs-12 col-sm-6 col-md-8">
                            <div class="intel-video">
                                <video width="100%" autoplay controls controlsList="nodownload">
                                <!-- <source src="movie.mp4" type="video/mp4"> -->
                                <source src="/images/intel-img/video/NZXT_BLD_PUBG.webm" type="video/webm">
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-4">
                            <div class="intel-list">
                                <div class="fps-image">
                                    <img src="/images/intel-img/PUBG-fps-image.png" alt="" class="img-response-w">
                                </div>
                                <div class="req-cols m-t">
                                    <div class="req-items-content">
                                        <div class="req-item">
                                            <div class="img-container m-r">
                                                <img src="images/icons/case-w-icon.svg" alt="">
                                            </div>
                                            <div class="text-content p-l">
                                                <div class="text-item text-grey">
                                                    <h4 class="text-upper text-bold m-a-0">Case</h4>
                                                    <p class="m-a-0">S340 Elite Black</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="req-item">
                                            <div class="img-container m-r">
                                                <img src="images/icons/mobo-w-icon.svg" alt="">
                                            </div>
                                            <div class="text-content p-l">
                                                <div class="text-item text-grey">
                                                    <h4 class="text-upper text-bold m-a-0">Mobo</h4>
                                                    <p class="m-a-0">Z370 GAMING PRO CARBON AC</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="req-item">
                                            <div class="img-container m-r">
                                                <img src="images/icons/cpu-w-icon.svg" alt="">
                                            </div>
                                            <div class="text-content p-l">
                                                <div class="text-item text-grey">
                                                    <h4 class="text-upper text-bold m-a-0">CPU</h4>
                                                    <p class="m-a-0">Intel 8700k</p>
                                                </div>
                                                <div class="text-item text-grey m-t">
                                                    <h4 class="text-upper text-bold m-a-0">CPU Cooler</h4>
                                                    <p class="m-a-0">Intel 8700k</p>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="req-item">
                                            <div class="img-container m-r">
                                                <img src="images/icons/gpu-w-icon.svg" alt="">
                                            </div>
                                            <div class="text-content p-l">
                                                <div class="text-item text-grey">
                                                    <h4 class="text-upper text-bold m-a-0">GPU</h4>
                                                    <p class="m-a-0">EVGA GTX 1080 8GB FTW Gaming ACX 3.0</p>
                                                </div>
                                                <div class="text-item text-grey m-t">
                                                    <h4 class="text-upper text-bold m-a-0">GPU Cooler</h4>
                                                    <p class="m-a-0">EVGA GTX 1080 8GB FTW Gaming ACX 3.0</p>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="req-items-content">
                                        <div class="req-item">
                                            <div class="img-container m-r">
                                                <img src="images/icons/ram-w-icon.svg" alt="">
                                            </div>
                                            <div class="text-content p-l">
                                                <div class="text-item text-grey">
                                                    <h4 class="text-upper m-a-0">Ram</h4>
                                                    <p class="m-a-0">G.SKILL TridentZ Series RGB 3200 Mhz 16GB</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="req-item">
                                            <div class="img-container m-r">
                                                <img src="images/icons/ssd-w-icon.svg" alt="">
                                            </div>
                                            <div class="text-content p-l">
                                                <div class="text-item text-grey">
                                                    <h4 class="text-upper m-a-0">SSD</h4>
                                                    <p class="m-a-0">CRUCIAL MX300 1TB</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="req-item">
                                            <div class="img-container m-r">
                                                <img src="images/icons/cooler-w-icon.svg" alt="">
                                            </div>
                                            <div class="text-content p-l">
                                                <div class="text-item text-grey">
                                                    <h4 class="text-upper m-a-0">Cooling</h4>
                                                    <p class="m-a-0">CRUCIAL MX300 1TB</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="req-item">
                                            <div class="img-container m-r">
                                                <img src="images/icons/settings-w-icon.svg" alt="">
                                            </div>
                                            <div class="text-content p-l">
                                                <div class="text-item text-grey">
                                                    <h4 class="text-upper m-a-0">Software</h4>
                                                    <p class="m-a-0">Microsoft Windows 10 Home</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="req-item">
                                            <div class="img-container m-r">
                                                <img src="images/icons/psu-w-icon.svg" alt="">
                                            </div>
                                            <div class="text-content p-l">
                                                <div class="text-item text-grey">
                                                    <h4 class="text-upper m-a-0">PSU</h4>
                                                    <p class="m-a-0">EVGA SuperNova G2 850W</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                    <!-- /.new-8th -->
                </div>
                <div class="clearfix"></div>
            </div>
        </div>
    </div>
    <!-- /.intro -->
</div>
</template>

<script>
export default {}
</script>

<style lang="css">
</style>
